import { useEffect, useRef, useState } from 'react'
import * as ResizeObserver from 'resize-observer-polyfill'

import isMatchingMediaQuery from 'utils/isMatchingMediaQuery'

const useMediaQuery = (query: string) => {
  const resizeObserver = useRef<ResizeObserver | null>(null)
  const [, updateState] = useState(new Date())

  useEffect(() => {
    resizeObserver.current = new ResizeObserver.default(() => updateState(new Date()))
    resizeObserver.current.observe(window.document.body)

    return () => {
      resizeObserver.current?.disconnect()
      resizeObserver.current = null
    }
  }, [])

  return isMatchingMediaQuery(query)
}

export default useMediaQuery
